import React from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Icon from 'components/Icon';
import {
  Events,
  getSegmentModelMetadata,
  handleAnalytics,
  SEGMENT_HERO_COLLECTION_TITLE,
} from '@foxcorp/delta-web-analytics';
import Style from './ActionButton.module.scss';

const WATCH_TEXT = 'Watch';

const ActionButton = ({
  clickHandler = () => {},
  description = '',
  episode = {},
  icon = null,
  isRestart = false,
  item = {},
  name = null,
  shouldRender = true,
  text = null,
  url = null,
  viewBox = null,
}) => {
  const customClickHandler = () => {
    const pageActionType = isRestart ? 'restart' : 'watch';
    const props = {
      page_action_type: pageActionType,
      page_item_type: 'hero',
      page_item_state: 'static image',
      page_item_container_title: name,
      page_item_vertical_position: 1,
      page_item_horizontal_position: 1,
      page_item_title: text,
      page_item_subtitle: description,
      page_item_cc: 'cc off',
      page_item_volume: 'volume off',
      page_playlist_length: 1,
      page_collection_title: SEGMENT_HERO_COLLECTION_TITLE,
      page_collection_type: 'general',
      page_collection_count: 1,
      page_video_uid: item.latestEpisode?.uID,
      page_webview_url: window.location.href,
      ...getSegmentModelMetadata(),
    };
    handleAnalytics({ event: Events.HERO_ITEM_SELECT_ACTION, props });
    clickHandler();
  };
  if (!shouldRender) return null;

  const { seasonNumber, episodeNumber } = episode;

  const watchText = text === WATCH_TEXT ? `${text} S${seasonNumber} E${episodeNumber}` : text;

  return url ? (
    <Link to={url} className={Style.actionLink} onClick={customClickHandler} onlyActiveOnIndex>
      <button
        className={classNames(Style.actionButton, Style[icon])}
        type="button"
        aria-label={watchText}
      >
        <div className={Style.iconContainer}>
          <Icon icon={icon} color="white" size="full" viewBox={viewBox} />
        </div>
        <label className={Style.label}>{watchText}</label>
      </button>
    </Link>
  ) : (
    <div className={Style.actionLink}>
      <button
        className={classNames(Style.actionButton, Style[icon])}
        onClick={clickHandler}
        type="button"
        aria-label={watchText}
      >
        <div className={Style.iconContainer}>
          <Icon icon={icon} color="white" size="full" viewBox={viewBox} />
        </div>
        <label className={Style.label}>{watchText}</label>
      </button>
    </div>
  );
};

ActionButton.propTypes = {
  clickHandler: PropTypes.func,
  description: PropTypes.string,
  episode: PropTypes.shape({}),
  icon: PropTypes.string,
  isRestart: PropTypes.bool,
  item: PropTypes.shape({}),
  name: PropTypes.string,
  shouldRender: PropTypes.bool,
  text: PropTypes.string,
  url: PropTypes.string,
  viewBox: PropTypes.string,
};

export default ActionButton;
